module.exports = __webpack_public_path__ + "static/case_study_sp-a4d96ee9c48b1810eca12403ac9ab69f.svg";